import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { Select, AutoComplete } from 'antd'
import { searchUsers } from '../../../../services/api'
import RowAutocomplete from '../RowAutocomplete/RowAutocomplete'

import styles from './UserSearchBar.module.css'
import { toJS } from 'mobx'

const UserSearchBar = ({ onSelect, showRights = false, dataAPI = [] }) => {
  const { Option } = Select

  const [options, setOptions] = useState([])
  const [searching, setSearching] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [autoCompleteValue, setAutoCompleteValue] = useState('')
  const [selectedOption, setSelectedOption] = useState('write')

  const abortControllerRef = useRef(null)

  useEffect(() => {
    console.log('dataAPII', toJS(dataAPI))
    if (searchValue) {
      setSearching(true)
      if (abortControllerRef.current) {
        abortControllerRef.current.cancel()
      }
      abortControllerRef.current = axios.CancelToken.source()
      setOptions([{ value: 'Recherche en cours...', disabled: true }])
      searchUsers(searchValue, abortControllerRef.current.token)
        .then((data) => {
          if (data.search === searchValue) {
            let filteredUsers = data.users.filter(
              (user) =>
                dataAPI.findIndex(
                  (collaborator) => collaborator.username === user.uid
                ) === -1
            )
            if (filteredUsers.length > 0) {
              setOptions(
                filteredUsers.map((user) => {
                  return {
                    value: user.uid,
                    data: {
                      uid: user.uid,
                      mail: user.mail || '',
                      fullName: user.cn,
                    },
                    label: (
                      <RowAutocomplete
                        uid={user.uid}
                        fullName={user.cn}
                        mail={user.mail}
                      />
                    ),
                  }
                })
              )
            } else {
              setOptions([{ value: 'Pas de résultats', disabled: true }])
            }
          }
        })
        .catch((error) => {
          console.error('Erreur lors de la recherche des utilisateurs', error)
          setOptions([])
        })
        .finally(() => {
          setSearching(false)
        })
    } else {
      setOptions([])
      setAutoCompleteValue('')
    }
  }, [searchValue, dataAPI])

  const handleSearch = (value) => {
    setAutoCompleteValue(value)
    setSearchValue(value)
  }

  const handleOptionChange = (value) => {
    setSelectedOption(value)
  }

  return (
    <div className={styles.container__autocomplete}>
      <div className={styles.searchbar}>
        {showRights ? (
          <Select
            className={styles.select}
            defaultValue="write"
            value={selectedOption}
            onChange={handleOptionChange}
          >
            <Option value="write">Écriture</Option>
            <Option value="read">Lecture</Option>
          </Select>
        ) : null}
        <AutoComplete
          className={styles.autocomplete}
          value={autoCompleteValue}
          options={options}
          onSelect={(selectedUid, option) => {
            const selectedValue = option.data
            setAutoCompleteValue('')
            const [firstName, lastName] = selectedValue.fullName.split(' ')
            onSelect({
              user: selectedValue.uid,
              mail: selectedValue.mail,
              right: selectedOption,
              firstName,
              lastName,
            })
            console.log('selectedOption', {
              user: selectedValue.uid,
              mail: selectedValue.mail,
              right: selectedOption,
              firstName,
              lastName,
            })
          }}
          onSearch={handleSearch}
          placeholder="Rechercher un utilisateur par email ou login"
        />
      </div>
    </div>
  )
}

export default UserSearchBar
